import { render, staticRenderFns } from "./PersonEmailForm.vue?vue&type=template&id=9fa4c60a"
import script from "./PersonEmailForm.vue?vue&type=script&lang=ts"
export * from "./PersonEmailForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports